import { HStack, StackProps, Text } from '@cardboard-ui/react';
import { TextLink } from 'apps/TenantApp/components/TextLink';
import SpaceIcon from 'components/SpaceIcon';
import { useSpaceColor } from 'hooks/useSpaceColor';
import React from 'react';
import { generatePath } from 'react-router-dom';
import { graphql, useFragment } from 'utils/graphClient';
import { SPACE_PATH } from 'utils/routes';
import { SpaceIndicator_space$key } from './__generated__/SpaceIndicator_space.graphql';

const spaceFragment = graphql`
  fragment SpaceIndicator_space on Space {
    id
    name
    color {
      light
      dark
    }
  }
`;

export interface SpaceIndicatorProps extends StackProps {
  space: SpaceIndicator_space$key;
  linkToSpace?: boolean;
}

export const SpaceIndicator = ({
  space: _space,
  linkToSpace,
  ...props
}: SpaceIndicatorProps) => {
  const space = useFragment(spaceFragment, _space);
  const color = useSpaceColor(space, { invert: true });

  // Adding this here for the short time a space may be rendered while it is being deleted
  if (!space) {
    return <></>;
  }

  const { id, name } = space;
  return (
    <HStack spacing={1} overflow="hidden" {...props}>
      <SpaceIcon color={color} />
      {linkToSpace ? (
        <TextLink to={generatePath(SPACE_PATH, { spaceId: id })} isTruncated>
          {name}
        </TextLink>
      ) : (
        <Text isTruncated>{name}</Text>
      )}
    </HStack>
  );
};
